import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=968f0d40&scoped=true"
import script from "./InputForm.vue?vue&type=script&lang=js"
export * from "./InputForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968f0d40",
  null
  
)

export default component.exports